module.exports = __webpack_public_path__ + "static/media/Team-Mobile.2160161d.jpg";